import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const profile = (params = {}): AxiosPromise => {
  return axios.get('/user/profile', { params })
}
